import { allRoles, isAuthorized, lazyLoadView, redirectHome, _ } from '@/router/routing'
import MainApp from '@/components/MainApp.vue'
import type { Route, RouteConfig } from 'vue-router'

// /error/... are code error routes

export const errorRoutes: RouteConfig[] = [
  {
    path: '/errors',
    name: 'errors',
    component: MainApp,
    redirect: () => redirectHome(),
    meta: {
      dummy: true,
    },
    children: [
      {
        path: '/403',
        name: '403',
        component: () => lazyLoadView(import('@/components/unauth-pages/Error403View.vue')),
        meta: {
          title: _('Unauthorized'),
          is_authorized: () => isAuthorized('403'),
          requires_auth: true,
          requires_tenant: false,
          requires_role: allRoles,
        },
      },
      {
        path: '/404',
        name: '404',
        component: () => lazyLoadView(import('@/components/unauth-pages/Error404View.vue')),
        meta: {
          title: _('Not found'),
          is_authorized: (route: Route) => isAuthorized(route),
          requires_auth: true,
          requires_tenant: false,
          requires_role: allRoles,
        },
      },
      {
        path: '/500',
        name: '500',
        component: () => lazyLoadView(import('@/components/unauth-pages/Error500View.vue')),
        meta: {
          title: _('Internal error'),
          is_authorized: (route: Route) => isAuthorized(route),
          requires_auth: true,
          requires_tenant: false,
          requires_role: allRoles,
        },
      },
      {
        path: '/reload',
        name: 'reload',
        component: () => lazyLoadView(import('@/components/unauth-pages/ErrorReloadView.vue')),
        meta: {
          title: _('Application updated'),
          is_authorized: (route: Route) => isAuthorized(route),
          requires_auth: true,
          requires_tenant: false,
          requires_role: allRoles,
        },
      },
    ],
  },
]
